export const undo = {
  name: "undo" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12.636 1.864a.9.9 0 0 1 0 1.272l-.963.964h.827a9.4 9.4 0 1 1-9.4 9.4.9.9 0 1 1 1.8 0 7.6 7.6 0 1 0 7.6-7.6h-.827l.963.964a.9.9 0 0 1-1.272 1.272l-2.5-2.5a.9.9 0 0 1 0-1.272l2.5-2.5a.9.9 0 0 1 1.272 0Z" clip-rule="evenodd"/></svg>`,
  keywords: ["undo"],
  category: "other" as const,
};
